import { FontSizeControlOptions } from "../../../common/TextResize";

export const DEFAULT_FONT_SIZE_CONTROL_OPTIONS: FontSizeControlOptions = {
  defaultValue: 16,
  minValue: 10,
  maxValue: 32,
  step: 1,
}